import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

import React, { Component, Children } from 'react';
import PropTypes from 'prop-types';
import * as colors from './colors';
import StepGroup from './StepGroup';
import { mapBsStyleToColor } from './utils';

var Stepper =
/*#__PURE__*/
function (_Component) {
  _inherits(Stepper, _Component);

  function Stepper() {
    _classCallCheck(this, Stepper);

    return _possibleConstructorReturn(this, _getPrototypeOf(Stepper).apply(this, arguments));
  }

  _createClass(Stepper, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          activeStep = _this$props.activeStep,
          bsStyle = _this$props.bsStyle,
          small = _this$props.small,
          color = _this$props.color,
          partial = _this$props.partial,
          vertical = _this$props.vertical;
      var activeColor = color || mapBsStyleToColor(bsStyle, {
        fallback: colors.success.base
      });
      var totalSteps = Children.count(children);
      var steps = Children.map(children, function (step, index) {
        var last = index === totalSteps - 1;
        var controlProps = {
          index: index,
          activeColor: activeColor,
          small: small,
          vertical: vertical
        };
        var overrideBsStyle = step.props.overrideBsStyle; // Extended from https://github.com/callemall/material-ui/blob/master/src/Stepper/Stepper.js

        var activeSteps = activeStep.toString().split('.');
        var activeIndex = parseInt(activeSteps[0], 10);
        controlProps.activeSubStep = activeSteps[1] ? parseInt(activeSteps[1], 10) : undefined;
        var connectorColor = index >= activeIndex ? colors.alloy : overrideBsStyle ? mapBsStyleToColor(overrideBsStyle, {
          fallback: colors.alloy
        }) : colors.success.base;
        controlProps.connectorColor = connectorColor;
        var connector = vertical ? React.createElement("div", {
          style: {
            flex: '1 1 auto',
            borderRight: "2px solid ".concat(connectorColor),
            paddingRight: small ? '6px' : '9px',
            margin: '4px 0',
            flexDirection: 'column'
          }
        }) : React.createElement("div", {
          style: {
            flex: '1 1 auto',
            borderTop: "2px solid ".concat(connectorColor),
            marginTop: small ? '6px' : '9px'
          }
        });

        if (activeIndex === index) {
          controlProps.active = true;
          controlProps.partial = partial;
        } else if (activeIndex > index) {
          controlProps.completed = true;
        } else if (activeIndex < index) {// do we want to add anything here?
        }

        return [React.cloneElement(step, _objectSpread({}, controlProps, {}, step.props, {
          index: controlProps.index
        })), !last && !(step.type === StepGroup) && connector];
      });
      var stepperStyle = vertical ? {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        alignItems: 'flex-start',
        height: '100%',
        width: 'fit-content'
      } : {
        display: 'flex',
        justifyContent: 'space-between',
        padding: '14px 0 0',
        marginBottom: '30px'
      };
      return React.createElement("div", {
        className: "stepper",
        style: stepperStyle
      }, steps);
    }
  }]);

  return Stepper;
}(Component);

export { Stepper as default };
Stepper.propTypes = {
  children: PropTypes.arrayOf(PropTypes.node),
  activeStep: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  partial: PropTypes.bool,
  bsStyle: PropTypes.string,
  color: PropTypes.string,
  small: PropTypes.bool,
  vertical: PropTypes.bool
};
Stepper.defaultProps = {
  bsStyle: 'success',
  small: false,
  vertical: false
};